// extracted by mini-css-extract-plugin
export var formContainer = "_l6-0";
export var message = "_l6-1";